module.exports = __webpack_public_path__ + "img/tk.b792aa42.svg";